import { getDegree, getDistance, getVelocity, getPressure } from "helpers";
import { Container } from "./style";

export const WeatherCityToday = ({
  feels,
  humidity,
  icon,
  max,
  min,
  pathIcon,
  precipitationProbability,
  pressure,
  selectDistance,
  selectPressure,
  selectTemp,
  selectVelocity,
  temperatureCurrent,
  visibility,
  wind,
  conditions = "",
}) => {
  const arrayWind = wind?.split(" ");
  return (
    <Container>
      <div className="now dwc-left">
        <div className="content-one">
          <div className="part-of">
            <h2>Ahora</h2>
            <p>{conditions}</p>
          </div>
          <div className="degree">
            <span className="current">
              {getDegree(temperatureCurrent, selectTemp)}C
            </span>
            <span className="">
              Sensación Térmica: {getDegree(feels, selectTemp)}C
            </span>
          </div>
        </div>
        <div className="icon content-two">
          <figure>
            <img width="100" height="100" src={pathIcon(icon)} />
          </figure>
        </div>
      </div>
      <div className="now dwc-right">
        <p className="first-e">
          Humedad: <span>{humidity}%</span>
        </p>
        <p>
          Posibilidad de lluvias:<span>{precipitationProbability}%</span>
        </p>
        <p>
          Presión: <span>{getPressure(pressure, selectPressure)}</span>
        </p>
        <p>
          Viento:
          <span>
            {arrayWind[0]} {getVelocity(arrayWind[1], selectVelocity)}
          </span>
        </p>
        <p>
          Visibilidad: <span>{getDistance(visibility, selectDistance)}</span>
        </p>
      </div>
    </Container>
  );
};
